//import { Capacitor } from '@capacitor/core';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgxEchartsModule } from 'ngx-echarts';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { JwtModule } from '@auth0/angular-jwt';
import { getAuthToken } from './auth.service';
import { IonicStorageModule } from '@ionic/storage-angular';
import { MyInterceptor } from './my.interceptor';
import { SharedModule } from './shared/shared.module';
// import 'echarts/theme/macarons'
// import 'echarts/theme/shine'
//import * as Sentry from "@sentry/capacitor";
//import * as SentryAngular from "@sentry/angular";
//import { environment } from '../environments/environment';

// Sentry.init(
//   {
//     dsn: "https://3fc516a110e947e6abc96b2cd103d966@o967553.ingest.sentry.io/5918765",
//     enableNative: Capacitor.isNativePlatform(),
//     release: "chargehq@1.0",
//     dist: "1",
//     environment: environment.name,
//   },
//   // Forward the init method from @sentry/angular
//   SentryAngular.init
// );

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    HttpClientModule,
    SharedModule,
    IonicStorageModule.forRoot(),
    // JwtModule will automatically add the Bearer token header to http requests
    JwtModule.forRoot({
      config: {
        tokenGetter: getAuthToken,
        allowedDomains: ['localhost:4001', '10.0.2.2:4001', 'api.chargehq.net', 'api.chqtest.net']
      }
    }),
    NgxEchartsModule.forRoot({
      echarts: () => import('echarts')
    }),
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: MyInterceptor, multi: true },
//    { provide: ErrorHandler, useValue: SentryAngular.createErrorHandler() }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
